export enum StorageKeys {
  DIRECTORY_TOKEN = 'directoryToken',
  ADMIN_TOKEN = 'adminToken',
  ROLE = 'role',
  MEILISEARCH_TOKEN = 'meilisearchToken',
  VIEW_CONTEXT = 'viewContext',
  IS_SSO = 'isSSO',

  USED_SUPABASE_PROVIDER_ID = 'usedSupabaseProviderId',
}

export class StorageService {
  directoryToken = {
    get: () => StorageService.getItem(StorageKeys.DIRECTORY_TOKEN),
    set: (value: string) =>
      StorageService.setItem(StorageKeys.DIRECTORY_TOKEN, value),
    remove: () => StorageService.removeItem(StorageKeys.DIRECTORY_TOKEN),
  };

  static usedSupabaseProviderId = {
    get: () => {
      const result = StorageService.getItem(
        StorageKeys.USED_SUPABASE_PROVIDER_ID,
      );

      return result;
    },
    set: (providerId: string) => {
      return StorageService.setItem(
        StorageKeys.USED_SUPABASE_PROVIDER_ID,
        providerId,
      );
    },
    remove: () => {
      return StorageService.removeItem(StorageKeys.USED_SUPABASE_PROVIDER_ID);
    },
  };

  static setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  static getItem(key: string) {
    return localStorage.getItem(key);
  }

  static removeItem(key: string) {
    localStorage.removeItem(key);
  }
}
